<div class="h-full w-full si-card">
    <div class="border-b px-4 py-2 flex items-center justify-between">
        <h3 class="pt-2">Saved Searches</h3>
        <a [routerLink]="[resultTabsetUrlsEnum.SAVEDSEARCHES]" [ngClass]="{ 'disabled': !savedSearchesData?.length }"
            class="mb-0 text-si-h4 font-medium">View My Saved Searches</a>
    </div>
    <div class="h-full" *ngIf="isLoading; else savedSearchesCard">
        <div class="flex justify-center items-center h-full w-full">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <ng-template #savedSearchesCard>
        <div class="h-full p-4 overflow-auto">
            <ng-container *ngIf="savedSearchesData?.length > 0; else empty">
                <div class="text-si-h4 font-normal" *ngFor="let savedSearchData of (savedSearchesData || []) | slice:0:6">
                    <p class="two-line-wrap mb-0">
                        <span [title]="savedSearchData.searchName" (click)="onRecentSavedSerch(savedSearchData)"
                            class="a cursor-pointer font-normal">{{savedSearchData.searchName}}</span>
                    </p>
                    <p class="value-color block text-light cursor-default mb-0 text-si-h6 font-normal">
                        last accessed {{savedSearchData.creationDate | date:'MMM, dd, yyyy'}}
                    </p>
                </div>
            </ng-container>
            <ng-template #empty>
                <p>You didn't save any searches yet.</p>
            </ng-template>
        </div>
    </ng-template>
</div>
